import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageInputComponentModule } from '@shared/localization';

import { AssetFieldsComponent } from './asset-fields/asset-fields.component';

@NgModule({
  imports: [
    CommonModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    MatTooltipModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    LanguageInputComponentModule,
  ],
  declarations: [AssetFieldsComponent],
  exports: [AssetFieldsComponent],
})
export class TelespotProtocolsUiModule {}
